import { defaultEntityId, defaultEntityName, entitiesString } from "./constants";

interface Entity {
  url?: string;
  name: string;
  id: string;
}

const entities: Array<Entity> = 
  entitiesString ? JSON.parse(entitiesString) : [];

export const getEntity = (): Entity => {
  return entities.find((e) => e.url === window.location.host) || { name: defaultEntityName, id: defaultEntityId };
}


